import React, { useEffect } from 'react';
import { ContractFragment } from '../../../generated/graphql';
import { Grid, Dialog, Button, DialogActions, DialogContent, DialogTitle, useTheme } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

import { FormInput } from '../../../components/form-input';
import useMediaQuery from '@mui/system/useMediaQuery';

interface InputContractTermsDialogProps {
  open: boolean;
  contract: ContractFragment;
  onSubmit?: (data: Partial<InputContractTermsFields>) => void;
  onClose?: () => void;
}

interface InputContractTermsFields {
  title?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  note?: string | null;
}

export function InputContractTermsDialog(props: InputContractTermsDialogProps) {
  const { contract: c, onSubmit, onClose, open } = props;

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.up('sm'));

  const { control, handleSubmit, reset } = useForm<InputContractTermsFields>({
    defaultValues: {
      title: c.title,
      startDate: c.startDate,
      endDate: c.endDate,
      note: c.note,
    },
  });

  useEffect(() => {
    reset({
      title: c.title,
      startDate: c.startDate,
      endDate: c.endDate,
      note: c.note,
    });
  }, [open, c, reset]);

  const onFormSubmit = (data: InputContractTermsFields) => {
    if (onSubmit) {
      onSubmit(data);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" fullScreen={!isSmall}>
      <DialogTitle>Podmienky prenájmu</DialogTitle>
      <DialogContent>
        <form>
          <Grid container spacing={1} sx={{ flexGrow: 1 }}>
            <Grid size={{ xs: 12, sm: 12 }}>
              <Controller
                name="title"
                control={control}
                render={({ field, fieldState }) => (
                  <FormInput
                    label="Názov prenájmu"
                    value={field.value ?? ''}
                    onChange={field.onChange}
                    errorText={fieldState.error?.message}
                  />
                )}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Controller
                name="startDate"
                control={control}
                render={({ field, fieldState }) => (
                  <FormInput
                    label="Začiatok"
                    type="date"
                    value={field.value?.substring(0, 10) ?? ''}
                    onChange={field.onChange}
                    errorText={fieldState.error?.message}
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Controller
                name="endDate"
                control={control}
                render={({ field, fieldState }) => (
                  <FormInput
                    label="Koniec"
                    type="date"
                    value={field.value?.substring(0, 10) ?? ''}
                    onChange={field.onChange}
                    errorText={fieldState.error?.message}
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              <Controller
                name="note"
                control={control}
                render={({ field, fieldState }) => (
                  <FormInput
                    label="Poznámka"
                    type={{ type: 'multiLine', maxRows: 10, minRows: 2 }}
                    value={field.value ?? ''}
                    onChange={field.onChange}
                    errorText={fieldState.error?.message}
                  />
                )}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Zatvoriť</Button>
        <Button onClick={handleSubmit(onFormSubmit)} variant="contained">
          Uložiť
        </Button>
      </DialogActions>
    </Dialog>
  );
}
